import axios from "axios";
import { StorageService } from "../services/storage.service";
import { CacheStoreKey } from "../enum/cacheStore.enum";
import { INIT_CACHE_STAMP, PRE_CACHE_TEXT, appendTimeStamp, getCacheStamp, setCacheStamp } from "./cacheManager";
export class Persister {
    public static async requestData(cacheStore: CacheStoreKey, type: 'POST' | 'GET', endpointUrl: string, body?: object,) {
        const requestStringWithBody = `${endpointUrl}${body ? JSON.stringify(body) : ''}`;
        // Normal nonCache request are not modified at all
        if (cacheStore === CacheStoreKey.noCache) {
            const response = type === 'POST' ? await axios.post(endpointUrl, body) : await axios.get(endpointUrl);
            return response;
        } else {
            const localResult = StorageService.getNetworkItem(requestStringWithBody);
            const cacheStampVal = getCacheStamp(cacheStore);

            const needRefetch = cacheStampVal.startsWith(PRE_CACHE_TEXT);

            // if (localResult && !needRefetch && cacheStampVal !== INIT_CACHE_STAMP) {
            // above line is commented because this logic `cacheStampVal !== INIT_CACHE_STAMP` cause to refetch loggedinuser twise at startup
            if (localResult && !needRefetch) {
                return JSON.parse(localResult);
            } else {
                // Sometimes we get a cached response from the server in prod env(don't know the exact reason). To avoid that add a stamp to gurentee that we will never get a cached resp.
                const noCacheUrl = appendTimeStamp(endpointUrl);
                const response = type === 'POST' ? await axios.post(noCacheUrl, body) : await axios.get(noCacheUrl);

                // cache only the succeed responses
                if (response.data.status) {
                    StorageService.setNetworkItem(requestStringWithBody, JSON.stringify(response));
                    setCacheStamp(cacheStore, cacheStampVal.replace(PRE_CACHE_TEXT, ''));
                }
                return response;
            }
        }
    }
}